(ns bec-data-format.types "Shared types for Clj and Cljs.")


(defrecord JSError
    [type name message])


(defrecord JSFunction
    [name])


(defrecord java_lang_Class
    [name])


(defrecord java_lang_Throwable ;; TODO: Add pretty-printer and make sure our logging stuff sort of prints this as a real (i.e. local) exception + stacktrace.
    [type message stack-trace cause])


(defrecord clojure_lang_ExceptionInfo ;; TODO: Add pretty-printer and make sure our logging stuff sort of prints this as a real (i.e. local) exception + stacktrace.
    [message data stack-trace cause])
